import { FC } from 'react'
import { Row, Col, Text, Breadcrumb } from '@/client/components'
import * as S from './styles'
import { FeaturedProps } from '../types'

export const Featured: FC<FeaturedProps> = ({ breadcrumb, title, subtitle }) => (
  <S.Featured>
    <Row>
      <Col>
        <Breadcrumb pages={breadcrumb} />
      </Col>
    </Row>
    <Row>
      <Col>
        <Text as='h2' color='primary' family='heading' margin='2rem 0 1rem'>
          {subtitle}
        </Text>
        <Text as='h1' size='xxlg' family='heading' weight='bold' margin='0 0 2.5rem' itemProp='name'>
          {title}
        </Text>
      </Col>
    </Row>
  </S.Featured>
)
